import { computed } from 'vue'

import { useRoute } from 'nuxt/app'

const getStringQueryValue = (value: unknown): string | undefined =>
  typeof value === 'string' && value ? value : undefined

/**
 * Предоставляет реактивный контекст запуска приложения внутри miniapp.
 *
 * @returns идентификаторы и признаки Telegram/VK miniapp
 */
export const useMiniapps = () => {
  const route = useRoute()

  const telegramChatId = computed(() =>
    getStringQueryValue(route.query.telegram_chat_id),
  )
  const vkUserId = computed(() => getStringQueryValue(route.query.vk_user_id))

  const isTelegramView = computed(() => Boolean(telegramChatId.value))
  const isVkView = computed(() => Boolean(vkUserId.value))

  return {
    telegramChatId,
    vkUserId,
    isTelegramView,
    isVkView,
  }
}
